import * as React from 'react';
import { useIntl } from 'react-intl';

import {
  BlackFridayIcon as VoucherDiscountIcon,
  PercentageDiscountIcon,
} from '@notino/react-styleguide';

import { ProductDiscount } from '../../ProductDiscount';

import { messages } from './messages';
import {
  VoucherDiscountInfoWrapper,
  VoucherDiscountIconWrapper,
} from './styled';

export type AlignType = 'right' | 'left';

export interface IVoucherDiscountInfoProps {
  discountAmount: string | JSX.Element;
  discountCode: string;
  percentage: number;
  icon: {
    type: 'BlackFriday' | 'Percentage';
    text: string;
  } | null;
}

export const VoucherDiscountInfo: React.FC<IVoucherDiscountInfoProps> = ({
  icon,
  percentage,
  ...props
}) => {
  const { formatMessage } = useIntl();

  return (
    <VoucherDiscountInfoWrapper>
      <ProductDiscount align={'right'} {...props} />

      {icon ? (
        <VoucherDiscountIconWrapper
          data-testid={'voucher-discount-icon'}
          hideDesktop={false}
          align={'right'}
        >
          {icon.type === 'Percentage' ? (
            <PercentageDiscountIcon percentage={percentage} />
          ) : (
            <VoucherDiscountIcon
              text={icon.text || formatMessage(messages.label)}
            />
          )}
        </VoucherDiscountIconWrapper>
      ) : null}
    </VoucherDiscountInfoWrapper>
  );
};
